/* =========================================================
   VIVA MAGAZINE — Shopify Theme JS
   ========================================================= */

'use strict';

/* --- Scroll header ---------------------------------------- */
(function () {
  const hdr = document.getElementById('site-header');
  if (!hdr) return;
  const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* --- Reveal on scroll ------------------------------------ */
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const io = new IntersectionObserver(
    entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    }),
    { threshold: 0.16 }
  );
  els.forEach(el => io.observe(el));
})();

/* --- Mobile nav ------------------------------------------ */
(function () {
  const toggle = document.getElementById('menu-toggle');
  const nav    = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = toggle.classList.toggle('is-open');
    nav.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    toggle.setAttribute('aria-expanded', open);
  });
})();

/* --- Sound toggle (hero video) -------------------------- */
(function () {
  const btn = document.getElementById('sound-btn');
  const vid = document.querySelector('.hero__bg video');
  if (!btn || !vid) return;
  btn.addEventListener('click', () => {
    vid.muted = !vid.muted;
    btn.textContent = vid.muted ? 'Sound off' : 'Sound on';
    if (!vid.muted) vid.play();
  });
})();

/* --- Cart drawer ----------------------------------------- */
const cartDrawer = (() => {
  const overlay = document.getElementById('cart-drawer-overlay');
  const drawer  = document.getElementById('cart-drawer');
  const openBtns = document.querySelectorAll('[data-open-cart]');
  const closeBtn = document.getElementById('cart-drawer-close');
  if (!drawer) return {};

  const open = () => {
    overlay?.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    fetchCart();
  };
  const close = () => {
    overlay?.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  };

  openBtns.forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  return { open, close };
})();

/* --- Fetch & render cart --------------------------------- */
async function fetchCart() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  } catch (e) { console.error('Cart fetch error', e); }
}

function renderCart(cart) {
  const itemsEl = document.getElementById('cart-drawer-items');
  const subtotalEl = document.getElementById('cart-subtotal');
  if (!itemsEl) return;

  if (!cart.item_count) {
    itemsEl.innerHTML = '<p style="color:var(--muted);text-align:center;padding:40px 0">Your bag is empty.</p>';
  } else {
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="byline" style="margin-top:4px">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_price)}</div>
          <div class="cart-item__qty">
            <button class="cart-item__qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="cart-item__qty-count">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'increase' ? qty + 1 : qty - 1;
        await updateCartItem(key, newQty < 0 ? 0 : newQty);
      });
    });
  }

  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

async function updateCartItem(key, qty) {
  try {
    const res  = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  } catch (e) { console.error('Cart update error', e); }
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count > 0 ? `(${count})` : '';
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* --- Quick add to cart ----------------------------------- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.quickAdd;
  const originalText = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      btn.textContent = 'Added ✓';
      await fetchCart();
      cartDrawer.open?.();
    } else {
      btn.textContent = 'Out of stock';
    }
  } catch (e) {
    btn.textContent = 'Error';
  }
  setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2400);
});

/* --- Ritual Finder --------------------------------------- */
(function () {
  const opts   = document.querySelectorAll('.ritual-opt');
  const result = document.getElementById('ritual-finder-result');
  if (!opts.length || !result) return;

  opts.forEach(opt => {
    opt.addEventListener('click', () => {
      opts.forEach(o => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');

      const badge  = result.querySelector('[data-ritual-badge]');
      const img    = result.querySelector('[data-ritual-img]');
      const title  = result.querySelector('[data-ritual-title]');
      const desc   = result.querySelector('[data-ritual-desc]');
      const pname  = result.querySelector('[data-ritual-product]');
      const price  = result.querySelector('[data-ritual-price]');

      if (badge)  badge.textContent  = opt.dataset.key;
      if (img)    img.src            = opt.dataset.img;
      if (title)  title.textContent  = opt.dataset.title;
      if (desc)   desc.textContent   = opt.dataset.desc;
      if (pname)  pname.textContent  = opt.dataset.product;
      if (price)  price.textContent  = opt.dataset.price;

      result.classList.add('is-visible');
      setTimeout(() => result.scrollIntoView({ behavior: 'smooth', block: 'center' }), 120);
    });
  });

  const resetBtn = document.getElementById('ritual-reset');
  resetBtn?.addEventListener('click', () => {
    result.classList.remove('is-visible');
    opts.forEach(o => o.classList.remove('is-selected'));
    document.querySelector('.ritual-finder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* --- Product gallery ------------------------------------- */
(function () {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.getElementById('product-gallery-main');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      const imgEl = mainImg.querySelector('img');
      if (imgEl && src) imgEl.src = src;
    });
  });
})();

/* --- Product tabs ---------------------------------------- */
(function () {
  const tabs   = document.querySelectorAll('.product-tabs__tab');
  const panels = document.querySelectorAll('.product-tabs__panel');
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      document.getElementById(`tab-${target}`)?.classList.add('is-active');
    });
  });
})();

/* --- Variant selection ----------------------------------- */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;
  const priceEl   = form.closest('section')?.querySelector('[data-product-price]');
  const variantInput = form.querySelector('[name="id"]');

  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      document.querySelectorAll(`.variant-btn[data-group="${group}"]`).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      const selected = [...document.querySelectorAll('.variant-btn.is-selected')].map(b => b.dataset.value);
      const matchedVariant = window.__vivaVariants?.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );
      if (matchedVariant && variantInput) {
        variantInput.value = matchedVariant.id;
        if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price);
      }
    });
  });
})();

/* --- Add to cart (product page) -------------------------- */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const formData = new FormData(form);
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (res.ok) {
        btn.textContent = 'Added to bag ✓';
        await fetchCart();
        cartDrawer.open?.();
      } else {
        const data = await res.json();
        btn.textContent = data.description || 'Unavailable';
      }
    } catch (err) {
      btn.textContent = 'Error — try again';
    }
    setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 3000);
  });
})();

/* --- FAQ accordion --------------------------------------- */
document.addEventListener('click', e => {
  const q = e.target.closest('.faq-item__q');
  if (!q) return;
  const item = q.closest('.faq-item');
  const isOpen = item.classList.contains('is-open');
  document.querySelectorAll('.faq-item.is-open').forEach(i => i.classList.remove('is-open'));
  if (!isOpen) item.classList.add('is-open');
});

/* --- Newsletter ------------------------------------------ */
(function () {
  const forms = document.querySelectorAll('.newsletter-form');
  forms.forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]')?.value;
      const btn   = form.querySelector('button');
      if (!email) return;
      btn.textContent = 'Subscribing…';
      btn.disabled = true;
      await new Promise(r => setTimeout(r, 800));
      btn.textContent = 'You\'re in ✓';
    });
  });
})();

/* --- Hover-play video tiles ------------------------------ */
document.querySelectorAll('.video-tile__frame video, .film-grid video').forEach(vid => {
  const frame = vid.closest('.video-tile__frame') || vid.closest('.vtile .frame');
  if (!frame) return;
  frame.addEventListener('mouseenter', () => vid.play().catch(() => {}));
  frame.addEventListener('mouseleave', () => { vid.pause(); });
});
